import { render, staticRenderFns } from "./xueya.vue?vue&type=template&id=bc8cc15e&scoped=true&"
import script from "./xueya.vue?vue&type=script&lang=ts&"
export * from "./xueya.vue?vue&type=script&lang=ts&"
import style0 from "./xueya.vue?vue&type=style&index=0&id=bc8cc15e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8cc15e",
  null
  
)

export default component.exports